import { create } from 'zustand';
import { funderApi } from '../services/api';
import type { Funder } from '../types';

interface FunderState {
  funders: Funder[];
  loading: boolean;
  error: string | null;

  fetchFunders: (filters?: Record<string, string>) => Promise<void>;
  createFunder: (data: Partial<Funder>) => Promise<Funder>;
  updateFunder: (id: string, data: Partial<Funder>) => Promise<Funder>;
  deleteFunder: (id: string) => Promise<void>;
  addInteraction: (id: string, data: any) => Promise<Funder>;
}

export const useFunderStore = create<FunderState>((set) => ({
  funders: [],
  loading: false,
  error: null,

  fetchFunders: async (filters) => {
    set({ loading: true, error: null });
    try {
      const funders = await funderApi.list(filters);
      set({ funders, loading: false });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  },

  createFunder: async (data) => {
    const funder = await funderApi.create(data);
    set((s) => ({ funders: [...s.funders, funder] }));
    return funder;
  },

  updateFunder: async (id, data) => {
    const updated = await funderApi.update(id, data);
    set((s) => ({
      funders: s.funders.map((f) => (f._id === id ? { ...f, ...updated } : f)),
    }));
    return updated;
  },

  deleteFunder: async (id) => {
    await funderApi.delete(id);
    set((s) => ({ funders: s.funders.filter((f) => f._id !== id) }));
  },

  addInteraction: async (id, data) => {
    const updated = await funderApi.addInteraction(id, data);
    set((s) => ({
      funders: s.funders.map((f) => (f._id === id ? { ...f, ...updated } : f)),
    }));
    return updated;
  },
}));
